module.exports = __webpack_public_path__ + "static/media/jobHunt.eeb86e2a.svg";